<app-page-title title="POS Ayarları"></app-page-title>

<div class="row">
  <!-- ── Tanımlı POS kasaları ─────────────────────────────────────────────── -->
  <div class="col-lg-7">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="text-primary mb-0">Tanımlı POS Kasaları</h5>
          <button type="button" class="btn btn-sm btn-secondary" (click)="newTerminal()">Yeni Ayar</button>
        </div>

        <div class="text-muted" *ngIf="terminals.length === 0">
          Henüz POS ayarı tanımlanmamış. Sağdaki formdan bir kasa seçerek başlayabilirsiniz.
        </div>

        <div class="table-responsive" *ngIf="terminals.length > 0">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th>Kasa</th>
                <th>Banka</th>
                <th>Cihaz</th>
                <th>Taksit</th>
                <th>Komisyon Oranları</th>
                <th class="text-end">İşlem</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let terminal of terminals">
                <td>{{ terminal.caseName }}</td>
                <td>
                  <app-bank-logo [bankName]="terminal.bankName" [size]="20"></app-bank-logo>
                </td>
                <td>
                  <span *ngIf="terminal.posDeviceId" class="badge bg-soft-primary text-primary">
                    <i class="bx bx-credit-card-front me-1"></i>{{ terminal.posDeviceName || ('#' + terminal.posDeviceId) }}
                  </span>
                  <span *ngIf="!terminal.posDeviceId" class="text-muted small">—</span>
                </td>
                <td>
                  <span *ngIf="terminal.allowsSingle" class="badge bg-secondary me-1">Peşin</span>
                  <span *ngIf="terminal.allowsInstallment" class="badge bg-secondary">
                    En fazla {{ terminal.maxInstallmentCount }} taksit
                  </span>
                </td>
                <td>
                  <span *ngFor="let rate of terminal.commissionRates" class="badge bg-light text-dark me-1">
                    {{ rate.installmentCount === 1 ? 'Peşin' : rate.installmentCount + ' Taksit' }}:
                    <ng-container *ngIf="rate.valueType === PosCommissionValueType.Rate">%{{ rate.value }}</ng-container>
                    <ng-container *ngIf="rate.valueType === PosCommissionValueType.FixedAmount">
                      {{ rate.value | currencyAmount: null: null: true }}
                    </ng-container>
                  </span>
                </td>
                <td class="text-end text-nowrap">
                  <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="edit(terminal)">
                    <i class="fas fa-pen"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger" (click)="delete(terminal)">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Form ─────────────────────────────────────────────────────────────── -->
  <div class="col-lg-5">
    <div class="card">
      <div class="card-body">
        <h5 class="text-primary mb-3">{{ isEditing ? 'POS Ayarını Düzenle' : 'Yeni POS Ayarı' }}</h5>

        <div class="mb-3">
          <label for="caseId">Kasa <span class="text-danger">*</span></label>
          <select id="caseId" class="form-control form-select" [(ngModel)]="model.caseId" [disabled]="isEditing">
            <option [ngValue]="undefined">...Kasa Seçiniz...</option>
            <option *ngFor="let item of availableCases" [ngValue]="item.id">{{ item.name }}</option>
          </select>
          <small class="text-muted">Bankaya bağlı kasalar listelenmez; o kasalara elle hareket girilemez.</small>
        </div>

        <div class="mb-3">
          <label for="bankId">Bağlı Banka <span class="text-danger">*</span></label>
          <select id="bankId" class="form-control form-select" [(ngModel)]="model.bankId">
            <option [ngValue]="undefined">...Banka Seçiniz...</option>
            <option *ngFor="let item of banks" [ngValue]="+item.value">{{ item.text }}</option>
          </select>
          <small class="text-muted">Komisyonun ödendiği banka.</small>
        </div>

        <div class="mb-3">
          <label for="posDeviceId">POS Cihazı</label>
          <select id="posDeviceId" class="form-control form-select" [(ngModel)]="model.posDeviceId">
            <option [ngValue]="null">Cihaz yok — kart elle çekilir</option>
            <option *ngFor="let device of devices" [ngValue]="device.id">
              {{ device.name }} ({{ device.serialNo }})
            </option>
          </select>
          <small class="text-muted">
            Seçilirse hızlı satışta kart tutarı bu cihaza gönderilir.
            Cihazlar <a routerLink="/case/pos-devices">POS Cihazları</a> ekranında tanımlanır.
          </small>
        </div>

        <div class="mb-3" *ngIf="model.posDeviceId">
          <label for="providerPaymentMethodCode">Bankaya Özel Ödeme Aracı Kodu</label>
          <input id="providerPaymentMethodCode" class="form-control" maxlength="20" placeholder="Boş: genel kart ödemesi"
                 [(ngModel)]="model.providerPaymentMethodCode">
          <small class="text-muted">
            Kartın belirli bir bankanın POS uygulamasından çekilmesi için sağlayıcının aracı kodu (Pavo: Mediator).
            Bilmiyorsanız boş bırakın.
          </small>
        </div>

        <div class="mb-2 form-check">
          <input id="allowsSingle" type="checkbox" class="form-check-input" [(ngModel)]="model.allowsSingle">
          <label for="allowsSingle" class="form-check-label">Peşin (tek çekim) kabul eder</label>
        </div>

        <div class="mb-2 form-check">
          <input id="allowsInstallment" type="checkbox" class="form-check-input" [(ngModel)]="model.allowsInstallment">
          <label for="allowsInstallment" class="form-check-label">Taksitli ödeme kabul eder</label>
        </div>

        <div class="mb-3" *ngIf="model.allowsInstallment">
          <label for="maxInstallmentCount">En Yüksek Taksit Sayısı <span class="text-danger">*</span></label>
          <input id="maxInstallmentCount" type="number" min="2" class="form-control"
                 [(ngModel)]="model.maxInstallmentCount">
        </div>

        <hr>

        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="form-label mb-0">Komisyon Oranları</label>
          <button type="button" class="btn btn-sm btn-secondary" (click)="addRate()">Satır Ekle</button>
        </div>
        <small class="text-muted d-block mb-2">
          Taksit sayısı 1 ise peşin (tek çekim) oranıdır. Satışta seçilen taksit sayısına
          birebir eşleşen bir oran tanımlı değilse tahsilat yapılamaz.
        </small>

        <div class="input-group mb-2" *ngFor="let rate of model.commissionRates; let i = index">
          <input type="number" min="1" class="form-control" placeholder="Taksit"
                 [(ngModel)]="rate.installmentCount" name="installmentCount-{{i}}">
          <select class="form-select" [(ngModel)]="rate.valueType" name="valueType-{{i}}">
            <option [ngValue]="PosCommissionValueType.Rate">Oran (%)</option>
            <option [ngValue]="PosCommissionValueType.FixedAmount">Sabit Tutar</option>
          </select>
          <input type="number" min="0" step="0.0001" class="form-control text-end" placeholder="Değer"
                 [(ngModel)]="rate.value" name="value-{{i}}">
          <button type="button" class="btn btn-danger" (click)="removeRate(i)"
                  *ngIf="model.commissionRates.length > 1">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="d-flex mt-3">
          <button type="button" class="btn btn-primary me-2" [disabled]="isDisabled" (click)="submit()">Kaydet</button>
          <button type="button" class="btn btn-secondary" *ngIf="isEditing" (click)="newTerminal()">Vazgeç</button>
        </div>
      </div>
    </div>
  </div>
</div>
